import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.hooks', {
    templateNotFound: 'Template not found',
    errorLoadingSubscriptionExpiredText: 'Sorry, we could not load the data. {br}Your subscription has expired.',
    errorLoadingTrialExpiredText: 'Sorry, we could not load the data. {br}Your trial has expired.',
    errorLoadingText: 'Sorry, we could not load the data.',
});
